import React from 'react';
import {injectIntl} from 'react-intl';
import getFormConfig from 'getFormConfig';
import FormField from '@FormComponents/FormField';

const ConnectAndRequestEmployeeForm = ({intl, type, state, setState, errors, setErrors, onChange}) => {
  const renderForm = () => {
    const formConfig = getFormConfig()[type];
    const fields = formConfig.map((field, i) => {
      const {name} = field;
      return (
        <FormField
          state={state}
          setState={setState}
          field={field}
          errors={errors}
          setErrors={setErrors}
          onChange={onChange}
          key={`component-${name}-${i}`} />
      );
    });
    return (
      <div>
        {fields}
      </div>
    );
  };

  return (
    <>
      <script type="text/javascript" id="hs-script-loader" async defer src={`//js.hs-scripts.com/${process.env.BROWSE_TALENT_HUBSPOT_PORTALID}.js`}></script>
      {renderForm()}
    </>
  );
};

export default injectIntl(ConnectAndRequestEmployeeForm);
